import React, { useState, useEffect } from "react";
import { Stepper, Step, StepLabel, Box } from "@mui/material";
import { useLocation } from "react-router-dom";

// Define the step labels
const steps = ["Profile", "Payment Gateway-1", "Payment Gateway-2"];

const StepProgress = () => {
  const location = useLocation();
  const [activeStep, setActiveStep] = useState(0);

  // Set the active step based on the current URL
  useEffect(() => {
    switch (location.pathname) {
      case "/profile":
        setActiveStep(0);
        break;
      case "/payment-gateway-1":
        setActiveStep(1);
        break;
      case "/payment-gateway-2":
        setActiveStep(2);
        break;
      default:
        setActiveStep(0);
    }
  }, [location.pathname]);

  return (
    <Box sx={{ width: "100%", padding: 2,}}>
      {/* Stepper Component */}
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepProgress;
